import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules, Router, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { BrowserUtils } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';


const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [{ path: '', loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule) }],
    canActivate: [MsalGuard],
    data: {
      title: 'Dashboard',
      ComponentName: 'DashboardComponent'
    }
  },
{
    path: 'Search',
    component: MainLayoutComponent,
    children: [{ path: '', loadChildren: () => import('./features/search/search.module').then(m => m.SearchComponentModule) }],
    canActivate: [MsalGuard],
    data: {
      title: 'search',
      ComponentName: 'CombinedSearchComponent'
    }
  },
  {
    path: 'projects',
    component: MainLayoutComponent,
    children: [{ path: '', loadChildren: () => import('./features/project/project.module').then(m => m.ProjectModule) }],
    canActivate: [MsalGuard],
    data: {
      title: 'Project',
      ComponentName: 'ProjectComponent'
    }
  },
  {
    path: 'tests',
    component: MainLayoutComponent,
    children: [{ path: '', loadChildren: () => import('./features/test/test.module').then(m => m.TestModule) }],
    canActivate: [MsalGuard],
    data: {
      title: 'Test',
      ComponentName: 'TestComponent'
    }
  },
  {
    path: 'certificates',
    component: MainLayoutComponent,
    children: [{ path: '', loadChildren: () => import('./features/certificate/certificate.module').then(m => m.CertificateModule) }],
    canActivate: [MsalGuard],
    data: {
      title: 'Certificate',
      ComponentName: 'CertificateComponent'
    }
  },
  {
    path: 'admin',
    component: MainLayoutComponent,
    children: [{ path: '', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) }],
    canActivate: [MsalGuard],
    data: {
      title: 'Admin',
      ComponentName: 'AdminComponent'
    }
  },
  {
  
    path: 'constructionelement',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => {
          return import('./features/construction-element/construction-element.module').then(
            (m) => m.ConstructionElementModule
          );
        },
      },
    ],
    canActivate: [MsalGuard],
    data: {
      title: 'ConstructionElement',
      ComponentName: 'ConstructionElementComponent',
    },
  },
  {
    path: 'login',
    loadChildren: () => import('./core/login/modules/login.module').then(m => m.LoginModule)
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { 
      preloadingStrategy: PreloadAllModules, 
      useHash: true, 
      scrollPositionRestoration: 'top', 
      anchorScrolling: "enabled", 
      onSameUrlNavigation: 'reload',
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? "enabledNonBlocking"
          : "disabled",
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
